import {axios, HOST, config} from './settiing';

export default {
  getDocumentList(customerId) {
    return axios.get(`${HOST}/resource/document/${customerId}`, config);
  }
}